import { ErrorHandler, inject, Injectable, Injector } from '@angular/core';

import { getError } from 'src/app/api/services/api-utils.service';

import { AnalyticsService } from './analytics.service';
import { BigQueryLoggingService } from './big-query-logging.service';

@Injectable({
  providedIn: 'root',
})
export class ExceptionLoggingService implements ErrorHandler {
  private readonly injector = inject(Injector);

  handleError(exception: unknown): void {
    this.handle(exception);
  }

  handle(exception: unknown, cause?: unknown, caught?: boolean): void {
    const eventName = caught ? 'Exception' : 'Uncaught Exception';
    let message = this.getExceptionMessage(exception);

    if (cause) {
      message += `; cause: ${this.stringify(cause)}`;
    }

    this.injector.get(AnalyticsService).track(eventName, { message });

    message += `; url: ${window.location.href}`;
    const result = this.injector
      .get(BigQueryLoggingService)
      .logEvent(eventName, message);

    if (result) {
      void result.catch(() => {});
    }

    console.error(...Array.from(arguments));
  }

  private getExceptionMessage(exception: unknown): string {
    const error = getError(exception);

    if (exception instanceof Error) {
      return `error: ${exception.toString()}`;
    }

    if (error?.code) {
      return `response: ${error.code}: ${error.message}`;
    }

    return `value: ${this.stringify(exception)}`;
  }

  private stringify(value: unknown): string {
    if (typeof value === 'string') {
      return value;
    }

    try {
      const serialized = JSON.stringify(value);
      return serialized === undefined ? String(value) : serialized;
    } catch {
      return String(value);
    }
  }
}
